import React from 'react';
import './MeasurementForm.css';

interface AdvertiserInputProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const AdvertiserInput: React.FC<AdvertiserInputProps> = ({
  value,
  onChange,
  disabled = false
}) => {
  return (
    <div className="form-group">
      <label htmlFor="advertiser">Advertiser <span className="required">*</span></label>
      <input
        type="text"
        id="advertiser"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Enter advertiser name"
        required
        disabled={disabled}
      />
    </div>
  );
};

export default AdvertiserInput;
